<template>
<section>
    <div class="row" v-if="this.selectedBranch !=='' && this.$parent.branchTables.length>0" >
        <div class="col-md-8">
            <div class="ibox-title">
                <h3><b>Dine In Tables</b></h3>
            </div>
            <div class="ibox-content c2d_cont_1">
                <div class="col-lg-2 col-md-3 col-sm-4 col-xs-6" v-for="(table, index) in this.$parent.branchTables" v-if="table.tableType===2 && !table.deleted" :key="index" @click="tableClicked($event, index, table)" data-toggle="tooltip" data-placement="top" :title="table.name">
                    <div class="widget style1 navy-bg" :id="table.id" :class="{'red-bg': table.status}" style="cursor:pointer">
                        <div class="row vertical-align">
                            <div class="col-xs-3" style="padding-top:5px !important">
                                <i class="fa fa-group fa-2x"></i>
                            </div>
                            <div class="col-xs-9 wrap-overflow">
                                <h2 class="font-bold style1-pos" style="margin-top:3px" >{{(table.name.length >5) ? table.name.substring(0, 5) + "...": table.name}}</h2>
                            </div>
                        </div>
                    </div>
                </div>                
            </div>

        </div>

        <div class="col-md-4">
            <div class="ibox-title">
                <h3><b>Take Away Tables</b></h3>
            </div>
            <div class="ibox-content c2d_cont_1">
                <div class="col-lg-4 col-md-6 col-sm-6" v-for="(table, index) in this.$parent.branchTables" v-if="table.tableType===1 && !table.deleted" :key="index" @click="tableClicked($event, index, table)" data-toggle="tooltip" data-placement="top" :title="table.name">
                    <div class="widget style1 navy-bg" :id="table.id" :class="{'red-bg': table.status}" style="cursor:pointer">
                        <div class="row vertical-align">
                            <div class="col-xs-3" style="padding-top:5px;">
                                <i class="fa fa-group fa-2x"></i>
                            </div>
                            <div class="col-xs-9 wrap-overflow">
                                <h2 class="font-bold style1-pos" style="margin-top:3px">{{(table.name.length >5) ? table.name.substring(0, 5) + "...": table.name}}</h2>
                            </div>
                        </div>
                    </div>
                </div>                
            </div>            

        </div>
    </div>


    <!-- Waiter Modal -->
    <div class="modal fade" id="assign_waiter" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title" id="assign_waiter_modalLabel">Assign Waiter to Table: {{this.$parent.selectedTable.name}}</h4>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-2"><h3 class="form" for="searchQuery"><b>Search Waiter:</b></h3></div>
                        <div class="col-md-10"><input type="text" name="searchQuery" id="searchQuery" class="form-control"  v-model="searchQuery" placeholder="e.g Waiter" /></div>
                    </div>
                    <div class="row">
                            <div class="col-lg-3" v-for="(waiter, index) in this.searchedWaiters" :key="index" @click="waiterClicked(waiter, index)">
                            <div class="widget style1 navy-bg waiter" :id="'waiter_' +waiter.id" style="cursor:pointer">
                                <div class="row vertical-align text-center">
                                    <div>
                                        <h2 class="font-bold">{{waiter.name}}</h2>
                                    </div>
                                </div>
                            </div>
                        </div>       
                        <!-- </div> -->
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                                 <button class="btn btn-success pull-right" @click="initializeOrder()">Reserve Table</button>
                        </div>
                    </div>
                    <br/>
                </div>
            </div>
        </div>
    </div>
</section>
</template>


<script>
    import User from '@/services/User'
    import Multiselect from 'vue-multiselect';
    export default {
      name: "BranchTables",
      data(){
          return {
                restaurants: [],
                selectedRestaurant: "",
                selectedTable: "",
                branches: [],
                menu: [],
                selectedwaiter:"",
                orderHistory: {
                        created:"",
                        statusesByStatusId:{
                            id:20,
                            name:"",
                            cssClass:""
                        }
                    },
                searchQuery:"",
        }
      },
      props:["selectedBranch"],
      components: {Multiselect},
        created() {
        },
        updated(){
        $('#assign_waiter').on('hidden.bs.modal', function (e) {
            $(".widget").removeClass("yellow-bg");
            this.selectedwaiter="";
             });
             $('[data-toggle="tooltip"]').tooltip();  
        },
        computed:{
            searchedWaiters () { //search waiter in waiter popup
                return this.$parent.branchWaiters.filter(waiter => {
                    return waiter.name.toLowerCase().includes(this.searchQuery.toLowerCase()) && waiter.deleted===false;
                });
            }
        },
        methods:{
            tableClicked: async function(event, index, table){
                this.selectedwaiter="";
                this.$parent.selectedTableIndex= index;
                this.$parent.selectedTable= table;
                if(table.tableType===2){
                    
                    if(!this.$parent.selectedTable.status){
                        this.$parent.orderObject.orderTypesByOrderTypeId.id= "2";
                        this.$parent.orderObject.orderTypesByOrderTypeId.type="Dine In";   
                        this.searchQuery="";
                        $("#assign_waiter").modal("show");
                        $(".widget").removeClass("yellow-bg");
                        $('#'+table.id).addClass("yellow-bg");
                    }
                    else{
                        this.$parent.selectedTableOrder= await this.$parent.getOrderObject(table.id)
                    }
                }else if(table.tableType===1){
                    
                    if(!this.$parent.selectedTable.status){
                        this.$parent.orderObject.orderTypesByOrderTypeId.id= "1";
                        this.$parent.orderObject.orderTypesByOrderTypeId.type="Take Away";
                        this.selectedwaiter="";
                        this.initializeOrder();
                    }else{
                        this.$parent.selectedTableOrder= await this.$parent.getOrderObject(table.id)
                    }
                }
    
            },
            waiterClicked: function(waiter, waiterIndex){ //selected waiter
                this.selectedwaiter= waiter;
                $(".waiter").removeClass('yellow-bg')
                $('#waiter_'+ waiter.id).addClass('yellow-bg');
            },
            initializeOrder: async function(){ //initialilze order--save this in local storage

                this.$parent.selectedTable.status= 1;
                let param= new URLSearchParams();
                param.append("table_id", this.$parent.selectedTable.id);
                param.append("table_status", this.$parent.selectedTable.status);
                this.$http.post(this.$store.state.mainAppURL + "pos/update_table_status", param) //update status to reserved in db
                .then(async resp=>{
                    console.log("Table Updated in database");

                if (this.selectedwaiter!=="") {
                    this.$parent.orderObject.waiter= this.selectedwaiter;
                }else{
                    this.$parent.orderObject.waiter=null;
                }
                this.$parent.orderObject.table= this.$parent.selectedTable;
                    // creating order initilize history
                    let date= new Date();
                    this.$parent.status.id=20;
                    this.$parent.orderHistory.created= date.getTime();
                    this.$parent.orderHistory.statusesByStatusId.id=20;
                    this.$parent.orderHistory.statusesByStatusId.name= "CREATED";
                    this.$parent.orderObject.orderHistoriesById.push(this.$parent.orderHistory);

                    let user= JSON.parse(localStorage.getItem("user"));
                    this.$parent.orderObject.usersByUserId.id= user.id;
                    this.$parent.orderObject.usersByUserId.fullName= user.fullName;
                    this.$parent.orderObject.branchesByBranchId= this.selectedBranch;
                    this.$parent.orderObject.paymentMethod.id=1;

                    await this.$parent.updateOrderObject(this.$parent.orderObject, this.$parent.selectedTable.id);
                    this.$parent.selectedTableOrder= await this.$parent.getOrderObject(this.$parent.selectedTable.id)
                    this.$parent.orderObject.orderHistoriesById=[];
                $('#assign_waiter').modal("hide");
                this.selectedwaiter="";
                })

            }
        }
    }
</script>
<style scoped>
.c2d_cont_1{
    height: 220px !important;
    overflow: auto;
}
/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1; 
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: #888; 
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555; 
}

.col-lg-1, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-md-1, .col-md-10, .col-md-11, .col-md-12, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-sm-1, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-xs-1, .col-xs-10, .col-xs-11, .col-xs-12, .col-xs-2, .col-xs-3, .col-xs-4, .col-xs-5, .col-xs-6, .col-xs-7, .col-xs-8, .col-xs-9{
    padding-right: 4px !important;
    padding-left: 4px !important;
}

.wrap-overflow{
  white-space: nowrap; 
  width: 70%; 
  overflow: hidden;
  margin-left: 2px;
}
</style>